'use client'

import { useEffect } from 'react'
import { trackClientError } from '@/lib/trackClientError'

export default function ClientErrorReporter() {
    useEffect(() => {
        function handleWindowError(event: ErrorEvent) {
            trackClientError({
                error: event.error ?? event.message,
                source: 'window_onerror',
            })
        }

        function handleUnhandledRejection(event: PromiseRejectionEvent) {
            trackClientError({
                error: event.reason,
                source: 'unhandled_rejection',
            })
        }

        window.addEventListener('error', handleWindowError)
        window.addEventListener('unhandledrejection', handleUnhandledRejection)

        return () => {
            window.removeEventListener('error', handleWindowError)
            window.removeEventListener('unhandledrejection', handleUnhandledRejection)
        }
    }, [])

    return null
}
